import { ShieldCheck } from "lucide-react";

import { useKeysQuery } from "@/entities/keys/queries";
import { Skeleton } from "@/shared/ui/skeleton";
import { KeyBlock } from "@/widgets/KeyBlock";
import { PageHeader } from "@/widgets/PageHeader";

export function SettingsKeysPage(): JSX.Element {
  const { data, isLoading, isError } = useKeysQuery();

  return (
    <>
      <PageHeader
        title={<>API <span className="text-gradient">ключи</span></>}
        subtitle="Хранятся в зашифрованном виде, используются только для ваших запусков"
      />

      <div className="mb-6 flex items-start gap-4 rounded-2xl border border-purple/30 bg-gradient-to-r from-purple/[0.08] to-cyan/[0.04] p-4 sm:p-5">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-purple to-purple-dark text-white shadow-glow-purple">
          <ShieldCheck className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-bold text-white">
            Для работы нужны два API-ключа
          </div>
          <div className="mt-1 text-sm leading-snug text-foreground/85">
            <span className="font-semibold text-purple">OpenAI</span> — для генерации сидов и брифов · <span className="font-semibold text-cyan">Yandex Cloud (Wordstat)</span> — для сбора частот.
            Хранятся зашифрованно, используются только в ваших запусках.
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className="grid gap-5 lg:grid-cols-2">
          <Skeleton className="h-72 w-full" />
          <Skeleton className="h-72 w-full" />
        </div>
      ) : isError || !data ? (
        <div className="glass-card p-6 text-sm text-pink">
          Не удалось загрузить статус ключей.
        </div>
      ) : (
        <div className="grid gap-5 lg:grid-cols-2">
          <KeyBlock
            provider="openai"
            brand="GPT-4o · embeddings · brief-генератор"
            state={data.openai}
            instructions={[
              <>
                Перейдите на{" "}
                <span className="font-mono text-cyan">
                  platform.openai.com/api-keys
                </span>
              </>,
              "Войдите и нажмите Create new secret key",
              "Скопируйте ключ сразу — потом он не покажется",
              "Вставьте в поле выше",
            ]}
          />
          <KeyBlock
            provider="yandex"
            brand="Wordstat API · сбор частотностей"
            state={data.yandex}
            instructions={[
              <>
                Откройте <span className="font-mono text-cyan">aistudio.yandex.ru</span>
              </>,
              "Профиль → API-ключи → Создать",
              <>
                Включите сервис <b className="text-white">Wordstat</b> в подписке
              </>,
              "Скопируйте ключ и вставьте",
              "Проверьте, что ключ привязан к биллингу Yandex Cloud",
            ]}
            warning={
              <>
                С <b className="text-white">18 мая 2026</b> Wordstat API стал
                платным. Если ключ не работает — проверьте баланс Yandex Cloud.
              </>
            }
          />
        </div>
      )}
    </>
  );
}
